module.exports = __webpack_public_path__ + "static/media/motivation-thumb.4e90806c.png";